import React, { useState, useEffect, useRef } from 'react'
import './index.scss'
import moment from 'moment'
import { useHistory, Link } from 'react-router-dom'
import { getWeightUnit } from '../../../constants'
import envConfigs from '../../../configs/envConfigs'
import { useTranslation } from 'react-i18next'
import Messages from '../../../constants/Messages'
import menuDots from '../../../assets/images/more-icon.svg'
import leftLine from '../../../assets/images/Left line.svg'
import flightIcon from '../../../assets/images/plane-filled-blue.png'
import rightLine from '../../../assets/images/Right line.svg'
import rightArrow from '../../../assets/images/icon-right-arrow.png'
import leftArrow from '../../../assets/images/icon-left-arrow.png'
import LoadingAnimation from '../../LoadingAnimation/LoadingAnimation'
const RecentBookingList = ({ recentBookings, isLoading }) => {
	const { t, i18n } = useTranslation(['labels', 'errors'])
	const isRTL = i18n.language === 'ar' || i18n.dir() === 'rtl';

	const [showDropdown, setShowDropdown] = useState(false)
	const [key, setKey] = useState(null)

	const [currentSlide, setCurrentSlide] = useState(0);
	const cardsPerSlide = 3;

	const totalSlides = recentBookings?.bookingList
		? Math.ceil(recentBookings.bookingList.slice(0, 9).length / cardsPerSlide)
		: 0;

	const goToNext = () => {
		if (currentSlide < totalSlides - 1) {
			setCurrentSlide((prev) => prev + 1);
		}
	};

	const goToPrevious = () => {
		if (currentSlide > 0) {
			setCurrentSlide((prev) => prev - 1);
		}
	};


	const history = useHistory()
	const { parentUrl } = envConfigs;
	const dropdownRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			const clickWrapper = event.target.closest('.three-dots-view');

			if (dropdownRef.current &&
				!dropdownRef.current.contains(event.target) &&
				!clickWrapper) {
				setShowDropdown(false);
			}
		};

		if (showDropdown) {
			document.addEventListener('mousedown', handleClickOutside);
		}

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [showDropdown]);


	const bookingStatusFunction = (recentBook) => {
		let status = recentBook?.bookingStatus
		if (status === 'X') {
			return (

				<span>{t('COMMON.CNC')}</span>

			)
		} else if (status === 'C') {
			return (

				<span>{t('COMMON.CONFIRMED')}</span>

			)
		} else if (status === 'Q') {
			return (

				<span className='other-text'>{t('COMMON.QUEUED')}</span>

			)
		} else if (status === 'R') {
			return (

				<span className='other-text'>{t('VIEWBKG.ST_REJECTED')}</span>

			)
		} else if (status === 'W') {
			return (

				<span className='other-text'>{'Waitlisted'}</span>

			)
		} else return
	}

	const redirectToTrackBooking = (evnt, result) => {
		const language = i18n.language ? i18n.language : 'en'
		evnt.stopPropagation()
		const airwayBill = result.shipmentIdentifierDetails
			? result.shipmentIdentifierDetails.shipmentPrefix +
			result.shipmentIdentifierDetails.masterDocumentNumber
			: ''
		window.open(
			`${parentUrl ? parentUrl : 'https://www.etihadcargo.com'
			}/${language}/e-services/shipment-tracking?awb=${airwayBill}`,
			'_blank'
		)
		setShowDropdown(false)

	}

	// const redirectToCopyBooking = (evnt, result) => {

	// 	evnt.stopPropagation()
	// 	const airwayBill = result.shipmentIdentifierDetails
	// 		? result.shipmentIdentifierDetails.shipmentPrefix +
	// 		  result.shipmentIdentifierDetails.masterDocumentNumber
	// 		: ''
	// 	history.push(`/booking/search/${airwayBill}`)
	// 			window.scrollTo(0, 0)

	// }

	const redirectToCopyBooking = (evnt, result) => {
		evnt.stopPropagation();
		const airwayBill = result.shipmentIdentifierDetails
			? result.shipmentIdentifierDetails.shipmentPrefix +
			result.shipmentIdentifierDetails.masterDocumentNumber
			: '';
		history.push({
			pathname: `/booking/search/${airwayBill}`,
			state: { isCopyFlow: true }
		});
		window.scrollTo(0, 0);
	};

	let routes = recentBookings?.flightSegments
		? recentBookings?.flightSegments.length - 1
		: 0



	const getFormatedTime = (value) => {
		let formattedTime = ''
		if (value) {
			let tempArray = value.split(':')
			formattedTime =
				parseInt(tempArray[0], 10) +
				'Hrs ' +
				(tempArray[1] && tempArray[1] != '00' ? tempArray[1] + 'Min ' : '')
		}
		return formattedTime
	}

	const threeDotsRef = useRef(null);
	useEffect(() => {
		if (!open && !currencyOpen && !showDropdown) return; // nothing open, no listener

		const handleClickOutside = (event) => {

			if (showDropdown && threeDotsRef.current && !threeDotsRef.current.contains(event.target)) {
				setShowDropdown(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, [showDropdown]);



	return (
		<>
			<div className={`recent-booking-container${isRTL ? ' rtl' : ''}`}>
				<div className='recent-booking-header'>
					<div className='recent-booking-header-text'>{t('COMMON.RECENT_BKG')}</div>
					<Link className='see-all-button' to='/manage-booking'>
						{t('DASHBOARD.SEE_ALL')}

					</Link>


				</div>

				{!isLoading &&
					recentBookings &&
					recentBookings.bookingList &&
					recentBookings.bookingList.length > 0 ? (
					<>
						<div className='recent-booking-all'>

							{recentBookings.bookingList
								.slice(currentSlide * cardsPerSlide, (currentSlide + 1) * cardsPerSlide)
								.map((recentBook, index) => (
									// recentBookings?.bookingList?.slice(0, 9)
									// 	.slice(currentSlide * cardsPerSlide, (currentSlide + 1) * cardsPerSlide)
									// 	.map((recentBook, index) => (
									<div className='recent-booking-card' key={index}>
										<div className='booking-card-header'>
											<div className='booking-card-header-left'>
												<div>
													<div className='booking-card-awb-number'>
														{recentBook?.shipmentIdentifierDetails?.shipmentPrefix}-
														{recentBook?.shipmentIdentifierDetails?.masterDocumentNumber}
													</div>
												</div>

												<div className={recentBook.bookingStatus === 'C'
													? 'status-badge-booking-card recent-booking-status-confirmed'
													: recentBook.bookingStatus === 'Q'
														? 'status-badge-booking-card recent-booking-status-queued'
														: 'status-badge-booking-card recent-booking-status-rejected'}>
													<span className="status-dot-booking-card"></span>
													<span
														className="booking-card-status booking-card-status-ellipsis"
														title={(() => {
															const status = recentBook?.bookingStatus;
															if (status === 'X') return t('COMMON.CNC');
															if (status === 'C') return t('COMMON.CONFIRMED');
															if (status === 'Q') return t('COMMON.QUEUED');
															if (status === 'R') return t('VIEWBKG.ST_REJECTED');
															if (status === 'W') return 'Waitlisted';
															return '';
														})()}
													>
														{bookingStatusFunction(recentBook)}
													</span>

												</div>
											</div>
											<div className='booking-card-header-right'>
												<Link
													className='view-text-booking-card'
													to={`/manage-booking/${recentBook?.shipmentIdentifierDetails?.shipmentPrefix}${recentBook?.shipmentIdentifierDetails?.masterDocumentNumber}`}
												>
													{t('COMMON.VIEW')}
												</Link>
												{/* <div > */}

												<img src={menuDots} alt='' className='three-dots-view' onClick={(e) => {
													setShowDropdown(!showDropdown)
													setKey(index)
												}} />
												{showDropdown && key === index &&
													<div className='recent-booking-dot-dropdown' ref={dropdownRef}>
														<ul className='dropdown-panel-booking'>
															<li
																className='panel-first-item-booking'
																onClick={(e) => redirectToTrackBooking(e, recentBook)}
															>
																{t('COMMON.TRACK')}
															</li>
															<div className='dropdown-divider'></div>
															<li
																className='panel-first-item-booking'
																onClick={(e) => redirectToCopyBooking(e, recentBook)}
															>
																{t('BKGLIST.COPY')}
															</li>

														</ul>
													</div>}

												{/* </div> */}

											</div>

										</div>
										<div className='booking-card-middle-container'>
											<div className='flight-details-left-block'>
												<span className='book-list-orgin'>{recentBook?.originCity}</span>
												<span className='book-list-orgin-code'>{recentBook?.origin}</span>
												<span className='book-list-arrival-time'>
													{moment(recentBook.flightSegments[0].segmentDepartureDate, 'DD-MMM-YYYY HH:mm:ss').format('HH:mm')}
												</span>
												<span className='book-list-arrival-date'>
													{moment(recentBook.shippingDate, 'DD-MMM-YYYY').format('DD MMM')}
												</span>

											</div>
											<div className='flight-details-middle-block'>
												<div className='flight-icon-images'>
													<div className='origin-destination-icon'></div>
													<div className='transit-line booking-details-transit-line' />
													{/* <img src={leftLine} alt='leftLine' className='left-line-flight' /> */}
													<img src={flightIcon} alt='Flight' title='Flight' />
													<div className='transit-line ' />
													<div className='origin-destination-icon '></div>
													{/* <img src={rightLine} alt='rightLine' className='left-line-flight' /> */}
												</div>
												{routes ? (
													<div className='duration'>
														<div className='recent-booking-stops'>{routes} {t('COMMON.STOP')}</div>
														<div className='recent-booking-flying-hours'>{getFormatedTime(recentBook?.cumulativeJourneyTime)}</div>
													</div>

												) : (
													<div className='duration'>
														<div className='recent-booking-flying-hours'>{getFormatedTime(recentBook?.cumulativeJourneyTime)}</div>
													</div>
												)}

											</div>
											<div className='flight-details-right-block'>
												<span className='book-list-orgin'>{recentBook?.destinationCity}</span>
												<span className='book-list-orgin-code'>{recentBook?.destination}</span>
												<span className='book-list-arrival-time'>
													{recentBook?.flightSegments?.length > 1
														? moment(recentBook.flightSegments[recentBook.flightSegments.length - 1].segmentArrivalDate, 'DD-MMM-YYYY HH:mm:ss').format('HH:mm')
														: moment(recentBook.flightSegments[0].segmentArrivalDate, 'DD-MMM-YYYY HH:mm:ss').format('HH:mm')}
												</span>
												<span className='book-list-arrival-date'>
													{moment(recentBook.arrivalDate, 'DD-MMM-YYYY').format('DD MMM')}
												</span>
											</div>
										</div>
										<div className='booking-card-footer'>
											<div className="cargo-type-booking-card">
												{recentBook?.commodity}&nbsp;|&nbsp;{recentBook?.product}&nbsp;|&nbsp;{recentBook?.pieces + (recentBook?.pieces > 1 ? 'pcs' : 'pc')}
												&nbsp;-&nbsp;{recentBook?.weight + getWeightUnit(recentBook?.weightUnit)}
											</div>
											{/* <span className="separator">|</span> */}
										</div>
									</div>
								))}






						</div>
						<div className="booking-carousel-buttons d-none d-lg-flex">
							<button
								className="carousel-btn"
								onClick={goToPrevious}
								disabled={currentSlide === 0}
							>
								<img src={leftArrow} className='btn-image' alt='Next' />
							</button>

							<button
								className="carousel-btn"
								onClick={goToNext}
								disabled={currentSlide >= totalSlides - 1}
							>
								<img src={rightArrow} className='' alt='Next' />
							</button>
						</div>
					</>
				) : (

					<div className='' id='booking-list'>
						{isLoading ? <LoadingAnimation /> : t(Messages.NO_BOOKINGS_AVAILABLE, { ns: 'errors' })}
					</div>

				)
				}
			</div>

			{/* <div className='recent-booking-container'>
				
				<div className='recent-booking-container_wrap'>
					{recentBookings &&
						recentBookings.bookingList &&
						recentBookings.bookingList.length > 0 ? (
						<table>
							<tr>
								<th>{t('COMMON.AWB_NUMBER')}</th>
								<th>{t('DASHBOARD.ORG_DEST')}</th>
								<th>{t('DASHBOARD.SHIPMT_DATE')}</th>
								<th style={{ width: '165px' }}>{t('DASHBOARD.DTLS')}</th>
								<th>{t('COMMON.STATUS')}</th>
								<th>{''}</th>
							</tr>
							{recentBookings.bookingList?.slice(0, 5)?.map((recentBook, key) => (
								<tr>
									<td>
										<Link
											className='link awbnum-link'
											to={`/manage-booking/${recentBook?.shipmentIdentifierDetails?.shipmentPrefix}${recentBook?.shipmentIdentifierDetails?.masterDocumentNumber}`}
										>
											{recentBook?.shipmentIdentifierDetails?.shipmentPrefix}-
											{recentBook?.shipmentIdentifierDetails?.masterDocumentNumber}
										</Link>
									</td>
									<td>
										<p className='other-text'>
											{recentBook?.origin}-{recentBook?.destination}
										</p>
									</td>
									<td>
										<p className='other-text'>
											{moment(recentBook?.shippingDate).format('DD MMM YYYY')}
										</p>
									</td>
									<td>
										<p className='other-text'>
											{recentBook?.product}&nbsp;
											{recentBook?.commodity}-
											{recentBook?.pieces + (recentBook?.pieces > 1 ? 'pcs' : 'pc')}
											/{recentBook?.weight + getWeightUnit(recentBook?.weightUnit)}
										</p>
									</td>
									{bookingStatusFunction(recentBook)}
									<td>
										<p
											className='link track-text'
											onClick={(e) => redirectToTrackBooking(e, recentBook)}
										>
											{t('COMMON.TRACK')} &nbsp;
											<img
												style={{ width: '15px', height: '20px' }}
												src={require('../../../assets/images/LinkBlue.svg').default}
												alt='Track' />
										</p>
									</td>
								</tr>
							))}
							<tr>
								<td>
									<Link className='track-text link' to='/manage-booking'>
										{t('DASHBOARD.VIEW_ALL')}
										<img
											style={{ width: '15px', height: '20px', marginLeft: '8px' }}
											src={require('../../../assets/images/LinkBlue.svg').default}
											alt={t('DASHBOARD.VIEW_ALL')} />
									</Link>
								</td>
							</tr>
						</table>
					) : (
						!isLoading && (
							<div className='empty-records mb-4' id='booking-list'>
								{t(Messages.NO_BOOKINGS_AVAILABLE, { ns: 'errors' })}
							</div>
						)
					)}
				</div>
			</div> */}
		</>
	)
}

export default RecentBookingList
